var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRaw = function SvgIconRaw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_raw_svg__a",
    d: "M12 0a12 12 0 0 1 12 12v12H12a12 12 0 1 1 0-24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_raw_svg__c",
    d: "M0 24V11.7A12 12 0 1 1 12 24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1988E0",
    d: "M35.3 9.7a16 16 0 0 1-.6 23.2L24 43 13.3 33l-.6-.7A16 16 0 1 1 35.3 9.7z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_raw_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_raw_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#2CD4ED",
    xlinkHref: "#icon_raw_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0DB4E2",
    d: "M35.3-9.3a16 16 0 0 1-.6 23.2L24 24 13.3 14l-.6-.7A16 16 0 1 1 35.3-9.3z",
    mask: "url(#icon_raw_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 19)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_raw_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_raw_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#3169FF",
    xlinkHref: "#icon_raw_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3153FF",
    d: "M11.3-9.3a16 16 0 0 1-.6 23.2L0 24l-10.7-10-.6-.7A16 16 0 1 1 11.3-9.3z",
    mask: "url(#icon_raw_svg__d)"
  })))));
};
export default SvgIconRaw;